export default {
  header: {
    reserve: 'Rezervēt vietu',
    finalize: 'Pabeigt rezervāciju'
  },
  home: {
    legend: {
      available: 'Brīva',
      reserved: 'Rezervēta',
      booked: 'Aizņemta'
    },
    summary: {
      selected: '{count} vieta izvēlēta | {count} vietas izvēlētas',
      total: 'Kopējā cena: {price}€',
      clear: '✖ Notīrīt izvēli',
      continue: 'Turpināt →'
    },
    error: {
      title: 'Izskatās, ka kāds bija ātrāks!',
      message: 'Jūsu izvēlētā vieta tika rezervēta. Apskatiet citas pieejamās iespējas.',
      button: 'IZVĒLĒTIES CITU VIETU'
    }
  },
  booking: {
    heading: 'Rezervācijas informācija',
    back: 'Atpakaļ',
    fields: {
      country: 'Valsts',
      firstName: 'Vārds',
      lastName: 'Uzvārds',
      phone: 'Tālruņa numurs',
      email: 'E-pasts',
      company: 'Uzņēmuma nosaukums',
      registration: 'Reģistrācijas numurs',
      description: 'Produkta apraksts',
      comments: 'Papildu komentāri',
      commentsOptional: '(neobligāti)',
      vatNumber: 'PVN numurs'
    },
    countries: {
      latvia: 'Latvija',
      lithuania: 'Lietuva',
      estonia: 'Igaunija',
      other: 'Cits'
    },
    errors: {
      country: 'Lūdzu izvēlieties savu valsti',
      firstName: 'Lūdzu ievadiet savu vārdu',
      lastName: 'Lūdzu ievadiet savu uzvārdu',
      phone: 'Lūdzu ievadiet savu tālruņa numuru',
      email: 'Lūdzu ievadiet derīgu e-pasta adresi',
      company: 'Lūdzu ievadiet uzņēmuma nosaukumu',
      registration: 'Lūdzu ievadiet reģistrācijas numuru',
      description: 'Lūdzu aprakstiet savu produktu',
      terms: 'Lūdzu piekrītiet noteikumiem',
      vatNumber: 'Lūdzu ievadiet savu PVN numuru'
    },
    inboxError: '{domain} e-pasta adreses netiek pieņemtas piegādes problēmu dēļ. Lūdzu izmantojiet citu adresi.',
    termsLink: 'NOTEIKUMI UN NOSACĪJUMI',
    termsText: 'Esmu izlasījis {link} un piekrītu tiem.',
    vat: {
      text: 'Mans uzņēmums ir reģistrēts PVN maksātājs un tam ir derīgs PVN numurs, kas izsniegts Lietuvā, Igaunijā vai citā Eiropas Savienības valstī (<u>!NE Latvijā!</u>). Tādēļ darījumam jāpiemēro apgrieztās PVN maksāšanas mehānisms (0% PVN).',
      hint: 'piem. EE123456789; LT12345679; LT123456789012',
      footnote: '*PVN direktīva 2006/112/EK 44. pants, 196. pants<br> Nodoklis (PVN) tiek piemērots saņēmēja valstī.<br> Apgrieztā PVN maksāšana'
    },
    vatLabel: 'PVN',
    total: 'KOPĀ:',
    confirm: 'Apstiprināt rezervāciju'
  },
  tooltip: {
    status: {
      available: 'Brīva',
      reserved: 'Rezervēta',
      booked: 'Aizņemta'
    },
    dimensions: 'Izmēri: 3x2 m',
    select: 'IZVĒLĒTIES VIETU',
    deselect: 'ATCELT IZVĒLI'
  },
  map: {
    foodCourt: 'ĒDINĀŠANAS ZONA UN PARTNERU PROMO ZONA',
    kidsWorkshops: 'BĒRNU DARBNĪCAS',
    entrance: 'IEEJA',
    gate: 'VĀRTI #{n}',
    foodSellers: 'ĒDIENU TIRGOTĀJI',
    kidsInflatables: 'BĒRNU PIEPŪŠAMO ATRAKCIJU PILSĒTIŅA UN',
    partnersPromoZone: 'PARTNERU PROMO ZONA'
  },
  thankyou: {
    heading: 'Paldies!',
    line1: 'Jūsu vietas (-u) reģistrācija ir saņemta.',
    line2: 'Drīzumā savā e-pastā saņemsiet rēķinu un papildu informāciju!',
    returnHome: 'Atgriezties uz sākumu',
    processing: 'Lūdzu uzgaidiet, tiek ģenerēts rēķins…',
    processingStep1: 'Tiek ģenerēts rēķins…',
    processingStep2: 'Tiek nosūtīts apstiprinājuma e-pasts…',
    processingNote: 'Lūdzu neaizveriet šo lapu.',
    registrationStartsIn: 'Reģistrācija sāksies pēc',
    days: 'Dienas',
    hours: 'Stundas',
    minutes: 'Minūtes',
    seconds: 'Sekundes'
  }
}
